/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP server attached to a remote_session_client, with the fields the org-admin UI needs to display and link to it.
 */
export type OrganizationMcpServer = {
  /**
   * The mcp_server id.
   */
  id: string;
  /**
   * The MCP server name; empty when unset (display falls back to the URL).
   */
  name?: string | undefined;
  /**
   * The owning project id.
   */
  projectId: string;
  /**
   * The owning project's slug, for linking to the MCP server in its project.
   */
  projectSlug?: string | undefined;
  /**
   * The MCP server slug.
   */
  slug?: string | undefined;
  /**
   * The remote MCP server URL; empty for non-remote (toolset-backed) servers.
   */
  url?: string | undefined;
};

/** @internal */
export const OrganizationMcpServer$inboundSchema: z.ZodMiniType<
  OrganizationMcpServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.optional(z.string()),
    project_id: z.string(),
    project_slug: z.optional(z.string()),
    slug: z.optional(z.string()),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
      "project_slug": "projectSlug",
    });
  }),
);

export function organizationMcpServerFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationMcpServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationMcpServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationMcpServer' from JSON`,
  );
}
